/* Feature tabs: a vertical list of items (ARIA tabs) plus matching thumbnails.
   Selecting an item swaps the large image, its caption and the text panel. */
(() => {
  'use strict';
  if (customElements.get('q-feature-tabs')) return;

  customElements.define('q-feature-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.figures = [...this.querySelectorAll('[data-ft-figure]')];
      this.thumbs = [...this.querySelectorAll('[data-ft-thumb]')];
      if (!this.tabs.length) return;

      this.onClick = (event) => {
        const control = event.target.closest('[data-ft-control]');
        if (!control || !this.contains(control)) return;
        this.select(Number(control.dataset.ftControl));
      };

      this.onKey = (event) => {
        const i = this.tabs.indexOf(event.target);
        if (i < 0) return;
        const last = this.tabs.length - 1;
        let next = null;
        switch (event.key) {
          case 'ArrowDown':
          case 'ArrowRight': next = i === last ? 0 : i + 1; break;
          case 'ArrowUp':
          case 'ArrowLeft': next = i === 0 ? last : i - 1; break;
          case 'Home': next = 0; break;
          case 'End': next = last; break;
          default: return;
        }
        event.preventDefault();
        this.select(next, true);
      };

      // Theme editor: selecting a block in the sidebar shows that item.
      this.onBlockSelect = (event) => {
        if (!this.contains(event.target)) return;
        const control = event.target.closest('[data-ft-control]');
        if (control) this.select(Number(control.dataset.ftControl));
      };

      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      if (!this.onClick) return;
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    select(index, focus = false) {
      if (!Number.isInteger(index) || index < 0 || index >= this.tabs.length) return;
      this.tabs.forEach((tab, i) => {
        const on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach((panel, i) => panel.classList.toggle('is-active', i === index));
      this.figures.forEach((figure, i) => {
        const on = i === index;
        figure.classList.toggle('is-active', on);
        if (on) figure.removeAttribute('aria-hidden');
        else figure.setAttribute('aria-hidden', 'true');
      });
      this.thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
      if (focus) this.tabs[index].focus();
    }
  });
})();
